import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API_BASE, getSource } from "@/lib/track";

export { API_BASE };

export const API_URL = API_BASE;

export const OFFERS = {
  aih_express_snapshot: { name: "Business Snapshot", price: "$9.99" },
  aih_full_assessment: { name: "Business Growth Assessment", price: "$99.99" },
};

export const startCheckout = async (lookupKey, customerEmail) => {
  const { data } = await axios.post(`${API_BASE}/payments/checkout`, {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
    customer_email: customerEmail || "",
    source: getSource(),
    guarantee_ack: true,
  });
  sessionStorage.setItem("aih_offer", lookupKey);
  window.location.href = data.checkout_url;
};

export const useCheckout = () => {
  const [loading, setLoading] = useState(null);
  const go = async (lookupKey, customerEmail) => {
    if (loading) return;
    setLoading(lookupKey);
    try {
      await startCheckout(lookupKey, customerEmail);
    } catch (e) {
      setLoading(null);
      toast.error("Checkout could not start. Please try again.");
    }
  };
  return { go, loading };
};
